var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1719 1.51562V14.748L18.8105 10.1094C19.25 9.62109 19.9824 9.62109 20.4707 10.1094C20.9102 10.5488 20.9102 11.2812 20.4707 11.7207L13.7812 18.3613C13.3418 18.8496 12.6094 18.8496 12.1699 18.3613L5.5293 11.7207C5.04102 11.2812 5.04102 10.5488 5.5293 10.1094C5.96875 9.62109 6.70117 9.62109 7.18945 10.1094L11.8281 14.748V1.51562C11.8281 0.880859 12.3164 0.34375 13 0.34375C13.6348 0.34375 14.1719 0.880859 14.1719 1.51562ZM6.75 15.1875L9.09375 17.5312H3.625C3.18555 17.5312 2.84375 17.9219 2.84375 18.3125V22.2188C2.84375 22.6582 3.18555 23 3.625 23H22.375C22.7656 23 23.1562 22.6582 23.1562 22.2188V18.3125C23.1562 17.9219 22.7656 17.5312 22.375 17.5312H16.8574L19.2012 15.1875H22.375C24.084 15.1875 25.5 16.6035 25.5 18.3125V22.2188C25.5 23.9766 24.084 25.3438 22.375 25.3438H3.625C1.86719 25.3438 0.5 23.9766 0.5 22.2188V18.3125C0.5 16.6035 1.86719 15.1875 3.625 15.1875H6.75ZM21.5938 20.2656C21.5938 20.9492 21.0566 21.4375 20.4219 21.4375C19.7383 21.4375 19.25 20.9492 19.25 20.2656C19.25 19.6309 19.7383 19.0938 20.4219 19.0938C21.0566 19.0938 21.5938 19.6309 21.5938 20.2656Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.8ae817d5b0a4e4ab9f3c7a7e4eddad23.svg";
export { ForwardRef as ReactComponent };